// Comparador genérico para ordenação de tabelas: null/undefined primeiro,
// números numericamente, strings em pt-BR case-insensitive com ordenação
// natural de números embutidos ("2" antes de "10").
export const compareValues = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return String(a).localeCompare(String(b), 'pt-BR', { numeric: true, sensitivity: 'base' });
};
